<template>
  <!-- SISTEMA -->
  <CDropdown
    v-auth-roles="{
      user: userAuth,
      roles: [const_roles.ROLE_ADMINISTRATOR],
    }"
    togglerText="Configuración"
    nav
    placement="bottom-end"
  >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_ADMINISTRATOR],
      }"
      to="/tipos-de-pensiones"
      >Tipo de pensiones</CDropdownItem
    >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_ADMINISTRATOR],
      }"
      to="/metodos-de-pago"
      >Métodos de pago</CDropdownItem
    >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_ADMINISTRATOR],
      }"
      to="/items"
      >Items</CDropdownItem
    >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_ADMINISTRATOR],
      }"
      to="/idiomas-nativos"
      >Idiomas Nativos</CDropdownItem
    >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_ADMINISTRATOR],
      }"
      to="/lugares-de-origen"
      >Lugares de origen</CDropdownItem
    >
  </CDropdown>
</template>
<script>
import Constants from "@/plugins/constants";
export default {
  name: "SystemMenu",
  props: ["toggleMenu"],
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  data() {
    return {
      const_roles: Constants.roles,
    };
  },
  methods: {
    tMenu() {
      this.toggleMenu();
    },
  },
};
</script>